import { Instagram, Facebook, Linkedin, Youtube } from 'lucide-react';
import XLogo from './icons/XLogo';
import type { SocialKey } from '../content/social';

// One icon per social network, with the current X logo (not the old bird).
export default function SocialIcon({ name, size = 18 }: { name: SocialKey; size?: number }) {
  if (name === 'x') return <XLogo size={size - 2} />;
  const Icon = { instagram: Instagram, facebook: Facebook, linkedin: Linkedin, youtube: Youtube }[name];
  return <Icon size={size} aria-hidden="true" />;
}
